import React from 'react'
import BrandLayout from '../components/Layouts/BrandLayout'
import ContingenciesContainer from '../containers/Contingencies/Contingencies.container'
import FooterContainer from '../containers/Footer/Footer.container'
import SearchBuyerPanelContainer from '../containers/SearchBuyerPanel/SearchBuyerPanel.container'
import TopNavbarContainer from '../containers/TopNavbar/TopNavbar.container'
import routes from '../config/settings/routes'
import ContingencyExpenseDialogContainer from '../containers/ContingencyExpenseDialog/ContingencyExpenseDialog.container'
import ContingencyExpenseSectionContainer from '../containers/ContingencyExpenseSection/ContingencyExpenseSection.container'
import ContingenciesTradedAmountsSectionContainer from '../containers/ContingenciesTradedAmountsSection/ContingenciesTradedAmountsSection.container'
import ContingenciesPurchasingMechanismsSectionContainer from '../containers/ContingenciesPurchasingMechanismsSection/ContingenciesPurchasingMechanismsSection.container'
import ContingenciesProductsServicesSectionContainer from '../containers/ContingenciesProductsServicesSection/ContingenciesProductsServicesSection.container'
import ContingenciesBuyersListSectionContainer from '../containers/ContingenciesBuyerListSection/ContingenciesBuyersListSection.container'
import ContingenciesPurchasesSectorSectionContainer from '../containers/ContingenciesPurchasesSectorSection/ContingenciesPurchasesSectorSection.container'

/**
 * The Contingencies's page.
 */
const Contingencies = () => {
  return (
    <BrandLayout footer={<FooterContainer margin="0" />}>
      <TopNavbarContainer menuActive={routes.contingencies} />
      <SearchBuyerPanelContainer />
      <ContingenciesContainer />
      <ContingencyExpenseSectionContainer />
      <ContingencyExpenseDialogContainer />
      <ContingenciesTradedAmountsSectionContainer />
      <ContingenciesPurchasingMechanismsSectionContainer />
      <ContingenciesPurchasesSectorSectionContainer />
      <ContingenciesProductsServicesSectionContainer />
      <ContingenciesBuyersListSectionContainer />
    </BrandLayout>
  )
}

export default Contingencies
